export enum CreditCalculationModel {
  Legacy = 'legacy',
  CostBased = 'cost_based',
}

export enum BillableUsageEventType {
  PagesProcessed = 'pages_processed',
  KimThreadCreated = 'kim_thread_created',
  KimInvocation = 'kim_invocation',
}

export const BILLABLE_USAGE_EVENT_LABELS: Record<BillableUsageEventType, string> = {
  [BillableUsageEventType.PagesProcessed]: 'Pages processed',
  [BillableUsageEventType.KimThreadCreated]: 'Kim thread',
  [BillableUsageEventType.KimInvocation]: 'Kim message',
};
